/**
 * PageHeader — top bar that matches the sidebar logo height (h-14).
 * Use this in every page to keep the horizontal alignment consistent.
 */
import React from "react";
import { cn } from "@/lib/utils";

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
}

export function PageHeader({ title, actions, className }: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex h-14 shrink-0 items-center justify-between border-b border-border px-6",
        className
      )}
    >
      <h1 className="font-mono text-[11px] font-semibold uppercase tracking-widest leading-none" style={{ fontFamily: '"JetBrains Mono", ui-monospace, monospace' }}>
        {title}
      </h1>
      {actions && (
        <div className="flex items-center gap-2 shrink-0 ml-4">{actions}</div>
      )}
    </div>
  );
}
